<template>
    <span>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    icon
                    v-on:click="$emit('click', $event)"
                    v-bind="attrs"
                    v-on="on"
                    style="margin-top: -30px"
                >
                    <v-icon :color="icon_color">{{ icon }}</v-icon>
                </v-btn>
            </template>
            <span>{{ text }}</span>
        </v-tooltip>
    </span>

</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            default: function () { return null; }
        },

        icon_color: {
            type: String,
            default: function () { return null; }
        },

        text: {
            type: String,
            default: function () { return "Set text"; }
        },
    },
}
</script>

<style lang="scss" scoped></style>